import { render, staticRenderFns } from "./ModalPrivacy.vue?vue&type=template&id=d0b810fc&scoped=true"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ModalPrivacy.vue?vue&type=style&index=0&id=d0b810fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b810fc",
  null
  
)

export default component.exports